const listeners = new Set();
let jinglePlaying = false;

export const getJinglePlaying = () => jinglePlaying;

export const setJinglePlaying = (playing) => {
  if (jinglePlaying === playing) return;
  jinglePlaying = playing;
  listeners.forEach((listener) => listener(playing));
};

export const subscribeJinglePlaying = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
